import React, { useState, useEffect } from "react";
import Modal from "antd/lib/modal/Modal";
import {
  Form,
  Input,
  InputNumber,
  Button,
  notification,
  Select,
  Row,
  Col,
} from "antd";
import axiosGet, { axiosPost } from "../../helpers/AxiosRequest";
import { UrlConstants } from "../../helpers/UrlConstantsHelper";
import { convertToObject } from "typescript";

const AddDriverCall = (props: any) => {
  const [visible, setVisible] = useState(false);
  const [username, setUsername]: any = useState(
    localStorage.getItem("employeename")
  );
  
  const [selectedValues, setSelectedValues]: any = useState({});
  const { Option } = Select;

  useEffect(() => {
    setVisible(props.visible);

  }, [props.visible]);


  const handleOk = (e: any) => {
    props.hideModal(false);
  };

  const handleCancel = (e: any) => {
    props.hideModal(false);
  };

  const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 16 },
  };

  const onFinish = (values: any) => {};

  const validateMessages = {
    required: "${label} is required!",
    types: {
      email: "${label} is not validate email!",
      number: "${label} is not a validate number!",
    },
  };

  const cabidchange = (e: any) => {
    let selectedValuesCopy = { ...selectedValues };
    selectedValuesCopy.cabid = e.target.value;
    setSelectedValues(selectedValuesCopy);
  };

  const onReasonChange = (e: any) => {
    let selectedValuesCopy = { ...selectedValues };
    selectedValuesCopy.action = e;
    setSelectedValues(selectedValuesCopy);
  };
  const ontypeChange = (e: any) => {
    let selectedValuesCopy = { ...selectedValues };
    selectedValuesCopy.type = e;
    setSelectedValues(selectedValuesCopy);
  };
  const remarkschange = (e: any) => {
    let selectedValuesCopy = { ...selectedValues };
    selectedValuesCopy.remarks = e.target.value;
    setSelectedValues(selectedValuesCopy);
  };


  const adddrivercall = () => {
    const options: any = {
        data: {
        cabId: selectedValues.cabid,
        reason: selectedValues.action,
        remarks: selectedValues.remarks,
        type: selectedValues.type,
        updateBy: username,
    }
    };
    console.log("selectedValues:", selectedValues);

    console.log(options);

    axiosPost(UrlConstants.adddrivercall, options)
      .then((resp: any) => {
        handleCancel("");
        let notificationInfo: any;

        notificationInfo = {
          header: "Driver Call Added",
        };

        openNotificationWithIcon("Success", notificationInfo);
      })
      .catch(function (error: any) {
        if (error.response) {
          console.log(error.response.data, error.response.status);
        }
        const notificationInfo = {
          header: "Driver Call Adding Failed",
          description: "Error Occurred ",
        };
        openNotificationWithIcon("Error", notificationInfo);
      });
  };

  const openNotificationWithIcon = (type: any, info: any) => {
    if (type === "Success") {
      notification.success({
        message: info.header,
        description: info.description,
      });
    } else if (type === "Error") {
      notification.error({
        message: info.header,
        description: info.description,
      });
    }
  };

  return (
    <Modal
      destroyOnClose={true}
      className="custom-modal-form"
      title={props.title}
      width={450}
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[]}
    >
      {/* <>{JSON.stringify(selectedValues)}</> */}
      <Form {...layout} name="nest-messages" onFinish={onFinish}>
        <Form.Item name={["cabid", "cabid"]} label="Cabid" rules={[]}>
          <Input
            defaultValue={selectedValues.cabid}
            value={selectedValues.cabid}
            onChange={cabidchange}
          />
        </Form.Item>
          <Form.Item name={["action", "action"]} label="Reason" rules={[]}>
            <Select
              placeholder="Reason"
              value={selectedValues.action}
              defaultValue={selectedValues.action}
              onChange={onReasonChange}
            >
              <Option key={1} value="Need Logout">
                Need Logout
              </Option>
              <Option key={2} value="Permission Request">
                Permission Request
              </Option>
              <Option key={3} value="Payment Issue">
                Payment Issue
              </Option>
              <Option key={4} value="Intercity">
                Intercity
              </Option>
              <Option key={5} value="Request for the trip">
                Request for the trip
              </Option>
              <Option key={6} value="Loacation Change">
               Loacation Change
              </Option>
              <Option key={7} value="Over load">
               Over load
              </Option>
              <Option key={8} value="Waiting for Closing">
                Waiting for Closing
              </Option>
              <Option key={9} value="Need Trip Charge">
                Need Trip Charge
              </Option>
              <Option key={10} value="Long Trip">
               Long Trip
              </Option>
              <Option key={11} value="Login Issue">
               Login Issue
              </Option>
              <Option key={12} value="Trip Change">
                Trip Change
              </Option>
              <Option key={13} value="OTP Issue">
                OTP Issue
              </Option>
              <Option key={14} value="Amount Received">
               Amount Received
              </Option>
              <Option key={15} value="Vehicle Issue">
               Vehicle Issue
              </Option>
              <Option key={16} value="Trip Cancel">
                Trip Cancel
              </Option>
              <Option key={17} value="Trip details">
               Trip details
              </Option>
              <Option key={18} value="Need Login">
               Need Login
              </Option>
              <Option key={19} value="OTP Request">
               OTP Request
              </Option>
              <Option key={20} value="Others">
                Others
              </Option>
            </Select>
          </Form.Item>
          <Form.Item name={["type", "type"]} label="Call Type" rules={[]}>
            <Select
              placeholder="Type"
              value={selectedValues.type}
              defaultValue={selectedValues.type}
              onChange={ontypeChange}
            >
              <Option key={1} value="Incoming">
                Incoming
              </Option>
              <Option key={2} value="Outgoing">
                Outgoing
              </Option>
            </Select>
          </Form.Item>
        <Form.Item name={["remarks", "remarks"]} label="Remarks">
          <Input
            defaultValue={selectedValues.remarks}
            value={selectedValues.remarks}
            onChange={remarkschange}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
        
            <Button
              className="custom-modal-form-submit-btn"
              htmlType="submit"
              onClick={adddrivercall}
            >
              Submit
            </Button>
          
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddDriverCall;
